import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Loading from '../../Common/Loading';
import CustomAlert from '../../Common/CustomAlert';
import go_n from '../../Common/Images/go_n.gif';
import go_o from '../../Common/Images/go_o.gif';
import back_n from '../../Common/Images/back_n.gif';
import back_o from '../../Common/Images/back_o.gif';

import popimg from "../../Common/Images/ImagesForAlert/popup_bg1.png";
import popbg from "../../Common/Images/ImagesForAlert/popup_bg2.png";
import popclose from "../../Common/Images/ImagesForAlert/popup_close_n.png";

const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;

interface FamilyAlert {
    Login: string;
    Password: string;
    Fname: string;
    SurName: string;
    Email: string;
    Status: string;
    RegisteredDate: string;
    Mobile: string;
    PostalCode: string;
    MDLicencesAvailable: string;
    MDLicencesUsed: string;
}

interface DropdownOption {
    label: string;
    value: string;
}

const styles = {
    body: {
        margin: '0px',
        fontFamily: 'Trebuchet MS, Arial, Helvetica, sans-serif',
        fontSize: '10pt',
        backgroundColor: 'white',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column' as const,
    },
    container: {
        padding: '5px',
        flex: 1,
        display: 'flex',
        flexDirection: 'column' as const,
        overflow: 'hidden',
    },
    titleBar: {
        color: 'black',
        // backgroundColor: 'aliceblue',
        padding: '8px',
        fontSize: '16pt',
        fontFamily: 'Arial',
        width: '100%',
        textAlign: 'center' as const,
        fontWeight: 'normal',
        // borderBottom: '1px solid #000000',
        boxSizing: 'border-box' as const,
    },
    filterRow: {
        fontFamily: 'Times New Roman',
        fontSize: '13pt',
        padding: '10px 5px',
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap' as const,
        gap: '15px',
        backgroundColor: '#f9f9f9',
        border: '1px solid black',
        marginBottom: '5px',

    },
    headerRow: {
        fontFamily: 'Arial',
        fontSize: '10pt',
        backgroundColor: '#c7ddfd',
        color: '#2859ac',
        height: '32px',
        textAlign: 'left' as const,
        borderBottom: '1px solid rgb(128 160 255)',
    },
    headerCell: {
        padding: '8px 10px',
        borderRight: '1px solid rgb(128 160 255)',
        borderBottom: '1px solid rgb(128 160 255)',
        textAlign: 'left' as const,
        whiteSpace: 'nowrap' as const,
        fontWeight: 'normal' as const,
    },
    row: {
        fontFamily: 'Arial',
        fontSize: '10pt',
        backgroundColor: 'white',
        verticalAlign: 'top',
        cursor: 'pointer',
        minHeight: '20px',
        color: 'black',
    },
    altRow: {
        fontFamily: 'Trebuchet MS',
        fontSize: '10pt',
        backgroundColor: '#F4FAFF',
        verticalAlign: 'top',
        cursor: 'pointer',
        minHeight: '20px',
        color: 'black',
    },
    cell: {
        padding: '8px 10px',
        fontSize: '10pt',
        borderRight: '1px solid rgb(128 160 255)',
        fontFamily: 'Arial',
        whiteSpace: 'nowrap' as const
    },
    paginationBar: {
        backgroundColor: '#c7ddfd',
        color: '#2859ac',
        fontFamily: 'Arial',
        fontSize: '12pt',
        fontWeight: 'bold' as const,
        textAlign: 'center' as const,
        padding: '8px',
        border: 'solid 1px #80A0FF',
        borderTop: 'solid 1px #80A0FF',
        width: '99%',
    },
    navLink: {
        textDecoration: 'none',
        color: '#003366',
        margin: '0 5px',
        cursor: 'pointer',
    },
    scrollableDiv: {
        flex: 1,
        overflowY: 'auto' as const,
        overflowX: 'auto' as const,
        border: '1px solid rgb(128 160 255)',
        width: '100%',
        backgroundColor: 'white',
        textAlign: 'left' as const,
    },
    dropdown: {
        fontFamily: 'Arial',
        fontSize: '12pt',
        border: 'solid 1px rgb(128 160 255)',
        padding: '2px',
        cursor: 'pointer',
        minWidth: '130px'
    },
    selectedRow: {
        fontFamily: 'Trebuchet MS',
        fontSize: '12pt',
        backgroundColor: 'orange',
        color: 'white',
        verticalAlign: 'top',
        cursor: 'pointer',
        minHeight: '20px',
    },
};

function EL_FamilyRegisteredFromAPP() {
    const navigate = useNavigate();

    const [isGoHovered, setIsGoHovered] = useState(false);
    const [isBackHovered, setIsBackHovered] = useState(false);

    const [countries, setCountries] = useState<DropdownOption[]>([]);
    const [selectedCountry, setSelectedCountry] = useState<string>('');
    const [sortBy, setSortBy] = useState<string>('0');

    const [period, setPeriod] = useState<string>('today');

    const initFromDate = new Date();
    initFromDate.setMonth(initFromDate.getMonth() - 1);
    const [fromDate, setFromDate] = useState<string>(initFromDate.toISOString().split('T')[0]);
    const [toDate, setToDate] = useState<string>(new Date().toISOString().split('T')[0]);

    const [alerts, setAlerts] = useState<FamilyAlert[]>([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);

    const [alertInfo, setAlertInfo] = useState({ show: false, message: '' });
    const [statusMsg, setStatusMsg] = useState<{ text: string, color: string } | null>(null);
    const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(null);
    const [hasSearched, setHasSearched] = useState(false);

    useEffect(() => {
        const fetchDropdowns = async () => {
            setLoading(true);
            try {
                const response = await fetch(`${API_BASE_URL}api/get_family_reg_dropdowns`);
                const result = await response.json();
                if (result.status === 'success') {
                    setCountries(result.countries);
                    if (result.countries.length > 0) {
                        setSelectedCountry(result.countries[0].value);
                    }
                } else {
                    setStatusMsg({ text: result.message, color: 'red' });
                }
            } catch (error: any) {
                setStatusMsg({ text: "Network Error loading dropdowns", color: 'red' });
            } finally {
                setLoading(false);
            }
        };
        fetchDropdowns();
    }, []);

    const fetchData = async () => {
        if (!selectedCountry) {
            setAlertInfo({ show: true, message: 'Please select a country.' });
            return;
        }

        setLoading(true);
        setHasSearched(true);
        setStatusMsg(null);
        setSelectedRowIndex(null);

        try {
            const queryParams = new URLSearchParams({
                country: selectedCountry,
                sortBy: sortBy,
                period: period,
                fromDate: fromDate,
                toDate: toDate
            });

            const response = await fetch(`${API_BASE_URL}api/get_family_reg_data?${queryParams}`);
            const result = await response.json();

            if (result.status === 'success') {
                setAlerts(result.data);

            } else {
                setStatusMsg({ text: result.message || "Failed to load data", color: 'red' });
            }
        } catch (error: any) {
            setStatusMsg({ text: error.message || "Network Error", color: 'red' });
        } finally {
            setLoading(false);
        }
    };

    const handleBack = () => {
        navigate('/SysAdmin');
    };

    const currentData = alerts;

    // const handlePageChange = (direction: string) => {
    //     if (direction === 'first') setCurrentPage(1);
    //     if (direction === 'prev' && currentPage > 1) setCurrentPage(p => p - 1);
    //     if (direction === 'next' && currentPage < totalPages) setCurrentPage(p => p + 1);
    //     if (direction === 'last') setCurrentPage(totalPages);
    //     setSelectedRowIndex(null);
    // };

    return (
        <div style={styles.body}>
            <div
                style={{
                    backgroundImage: `url(${popimg}), url(${popbg})`,
                    backgroundRepeat: "no-repeat, no-repeat",
                    backgroundPosition: "left center, right center",
                    backgroundSize: "30% 100%, 70% 100%",
                    height: "16px",
                    color: "white",
                    padding: "7px 0px",
                    fontWeight: "bold",
                    fontSize: "12pt",
                    fontFamily: "arial",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "10px",
                }}
            >
                <span style={{ marginLeft: "10px" }}>
                    User not completed MD
                </span>
                <img
                    src={popclose}
                    alt="close"
                    height="30px"
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/SysAdmin")}
                />
            </div>
            <div style={styles.container}>
                <div style={styles.titleBar}>
                    Families Registered From APP
                </div>

                <div style={styles.filterRow}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            Country&nbsp;:&nbsp;
                            <select
                                style={styles.dropdown}
                                value={selectedCountry}
                                onChange={(e) => setSelectedCountry(e.target.value)}
                            >
                                {countries.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
                            </select>

                            &nbsp;&nbsp;&nbsp;&nbsp;Sort By&nbsp;:&nbsp;
                            <select
                                style={{ ...styles.dropdown, minWidth: '270px' }}
                                value={sortBy}
                                onChange={(e) => setSortBy(e.target.value)}
                            >
                                <option value="0">Postal Code, Registered date Descending</option>
                                <option value="1">Registered date Descending</option>
                            </select>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', gap: "4px" }}>
                            <input type="radio" id="rdoToday" name="period" value="today" checked={period === 'today'} style={{ margin: "0" }} onChange={(e) => setPeriod(e.target.value)} />
                            <label htmlFor="rdoToday" style={{ marginRight: "10px" }}>Today</label>

                            <input type="radio" id="rdoYesterDay" name="period" value="yesterday" checked={period === 'yesterday'} style={{ margin: "0" }} onChange={(e) => setPeriod(e.target.value)} />
                            <label htmlFor="rdoYesterDay" style={{ marginRight: "10px" }}>Yesterday</label>

                            <input type="radio" id="rdoThisWeek" name="period" value="thisWeek" checked={period === 'thisWeek'} style={{ margin: "0" }} onChange={(e) => setPeriod(e.target.value)} />
                            <label htmlFor="rdoThisWeek" style={{ marginRight: "10px" }}>This Week</label>

                            <input type="radio" id="rdoThisMonth" name="period" value="thisMonth" checked={period === 'thisMonth'} style={{ margin: "0" }} onChange={(e) => setPeriod(e.target.value)} />
                            <label htmlFor="rdoThisMonth" style={{ marginRight: "10px" }}>This Month</label>

                            <input type="radio" id="rdoSpecifyPeriod" name="period" value="specifyPeriod" checked={period === 'specifyPeriod'} style={{ margin: "0" }} onChange={(e) => setPeriod(e.target.value)} />
                            <label htmlFor="rdoSpecifyPeriod" style={{ marginRight: "10px" }}>Specify Period</label>

                            &nbsp;&nbsp;&nbsp;From:
                            <input
                                type="date"
                                value={fromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                                disabled={period !== 'specifyPeriod'}
                            />
                            &nbsp;&nbsp;&nbsp;&nbsp;To:
                            <input
                                type="date"
                                value={toDate}
                                onChange={(e) => setToDate(e.target.value)}
                                disabled={period !== 'specifyPeriod'}
                            />
                        </div>
                    </div>

                    <div
                        style={{
                            marginLeft: 'auto',
                            display: 'flex',
                            gap: '20px',
                            alignItems: 'center',
                            marginRight: "8%"
                        }}
                    >
                        <button
                            onClick={fetchData}
                            disabled={loading}
                            style={{
                                padding: '4px 20px',
                                backgroundColor: loading ? '#119ECC' : '#119ECC',
                                border: '2px solid orange',
                                // borderRadius: '3px',
                                cursor: loading ? 'not-allowed' : 'pointer',
                                fontFamily: 'Arial',
                                fontSize: '10pt',
                                minWidth: '70px',
                                color: 'white',


                            }}
                        >
                            GO
                        </button>

                        <button
                            onClick={handleBack}
                            disabled={loading}
                            style={{
                                padding: '4px 20px',
                                backgroundColor: loading ? '#119ECC' : '#119ECC',
                                border: '2px solid orange',
                                // borderRadius: '3px',
                                cursor: loading ? 'not-allowed' : 'pointer',
                                fontFamily: 'Arial',
                                fontSize: '10pt',
                                minWidth: '70px',
                                color: 'white',

                            }}
                        >
                            CLOSE
                        </button>
                    </div>
                </div>

                {statusMsg && (
                    <div style={{ textAlign: 'center', color: statusMsg.color, fontWeight: 'bold', marginBottom: '5px' }}>
                        {statusMsg.text}
                    </div>
                )}


{hasSearched && (

                <div style={styles.scrollableDiv}>
                    <table
                        cellPadding={0}
                        cellSpacing={0}
                        style={{
                            borderCollapse: 'collapse',
                            display: 'inline-table',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        <thead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                            <tr style={styles.headerRow}>
                                <th style={styles.headerCell}>#</th>
                                <th style={styles.headerCell}>Login</th>
                                <th style={styles.headerCell}>Password</th>
                                <th style={styles.headerCell}>FirstName</th>
                                <th style={styles.headerCell}>SurName</th>
                                <th style={styles.headerCell}>Email</th>
                                <th style={styles.headerCell}>Status</th>
                                <th style={styles.headerCell}>Registered Date</th>
                                <th style={styles.headerCell}>Mobile</th>
                                <th style={styles.headerCell}>Post Code</th>
                                <th style={styles.headerCell}>MDs_Available</th>
                                <th style={{ ...styles.headerCell, width: "100%" }}>MDs_Used</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan={12} style={{ padding: '10px', textAlign: 'center' }}><Loading /></td></tr>
                            ) : (
                                currentData.map((row, index) => {
                                    const isSelected = selectedRowIndex === index;
                                    let rowStyle = index % 2 === 0 ? styles.altRow : styles.row;
                                    if (isSelected) rowStyle = styles.selectedRow;

                                    const serialNumber = index + 1;

                                    return (
                                        <tr
                                            key={`${row.Login}-${index}`}
                                            style={rowStyle}
                                            onClick={() => setSelectedRowIndex(index)}
                                        >
                                            <td style={{ ...styles.cell, width: '40px', textAlign: 'center' }}>{serialNumber}</td>
                                            <td style={styles.cell}>{row.Login}</td>
                                            <td style={styles.cell}>{row.Password}</td>
                                            <td style={styles.cell}>{row.Fname}</td>
                                            <td style={styles.cell}>{row.SurName}</td>
                                            <td style={styles.cell}>{row.Email}</td>
                                            <td style={styles.cell}>{row.Status}</td>
                                            <td style={styles.cell}>{row.RegisteredDate}</td>
                                            <td style={styles.cell}>{row.Mobile}</td>
                                            <td style={styles.cell}>{row.PostalCode}</td>
                                            <td style={styles.cell}>{row.MDLicencesAvailable}</td>
                                            <td style={{ ...styles.cell, width: "100%" }}>{row.MDLicencesUsed}</td>
                                        </tr>
                                    );
                                })
                            )}
                            {currentData.length === 0 && !loading && (
                                <tr>
                                    <td colSpan={12} style={{ padding: '10px', textAlign: 'center', color: '#555' }}>
                                        No Data Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
)}

                {/* {alerts.length > 0 && (
                    <div style={styles.paginationBar}>
                        <span style={styles.navLink} onClick={() => handlePageChange('first')}>&lt;&lt;</span>
                        <span style={styles.navLink} onClick={() => handlePageChange('prev')}>&lt;</span>
                        <span style={{ margin: '0 10px' }}>
                            {currentPage} of {totalPages || 1}
                        </span>
                        <span style={styles.navLink} onClick={() => handlePageChange('next')}>&gt;</span>
                        <span style={styles.navLink} onClick={() => handlePageChange('last')}>&gt;&gt;</span>
                    </div>
                )} */}
            </div>

            {alertInfo.show && (
                <CustomAlert
                    message={alertInfo.message}
                    onClose={() => setAlertInfo({ ...alertInfo, show: false })}
                />
            )}
        </div>
    );
}

export default EL_FamilyRegisteredFromAPP;